import React from "react";
import { makeStyles } from "tss-react/mui";
import { SystemColorsEnum } from "../../style/types.js";
import "@mui/material";
import "../../style/hooks.js";
const useStyles = makeStyles()((theme) => ({
  circle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    borderRadius: "50%",
    color: theme.palette.warning.contrastText
  },
  circleLarge: {
    width: theme.spacing(6),
    minWidth: theme.spacing(6),
    height: theme.spacing(6)
  },
  circleMedium: {
    width: theme.spacing(4),
    minWidth: theme.spacing(4),
    height: theme.spacing(4)
  },
  circleSmall: {
    width: theme.spacing(3),
    minWidth: theme.spacing(3),
    height: theme.spacing(3)
  },
  circleLabelSmall: {
    fontSize: "12px",
    lineHeight: "23px"
  },
  circleLabel: {
    top: theme.spacing(2),
    fontSize: "20px",
    lineHeight: 0
  },
  circleLabelDefault: {
    color: theme.palette.primary.contrastText
  },
  circleLabelInverted: {
    color: theme.palette.text.primary
  }
}));
function CircleBox({ letter, color, size = "large", className }) {
  const { classes: styles, cx } = useStyles();
  function getSizeClass() {
    const circleSizeMapping = {
      large: styles.circleLarge,
      medium: styles.circleMedium,
      small: styles.circleSmall
    };
    return circleSizeMapping[size];
  }
  function getLetterColorClass() {
    switch (color) {
      case SystemColorsEnum.Beige:
      case SystemColorsEnum.WarmYellow:
      case SystemColorsEnum.YellowNeon:
      case SystemColorsEnum.Mint:
      case SystemColorsEnum.SystemGrey:
        return styles.circleLabelInverted;
      default:
        return styles.circleLabelDefault;
    }
  }
  return /* @__PURE__ */ React.createElement("div", { className: cx(styles.circle, getSizeClass(), className), style: { backgroundColor: color } }, /* @__PURE__ */ React.createElement(
    "span",
    {
      className: cx(getLetterColorClass(), {
        [styles.circleLabel]: size === "large",
        [styles.circleLabelSmall]: size !== "large"
      })
    },
    letter
  ));
}
export {
  CircleBox
};
//# sourceMappingURL=CircleBox.js.map
